import { DbMongoBaseInfos } from "./db-mongo-base-infos";

import { OrderProductType } from "./order-product-type";
import { OrderManualTaskTemplateTypes } from "./order-manual-task-template-types";
import { ERPWorkOrderTriggerInfos } from "./erp-work-order-trigger-infos";
import { ERPWorkOrderHeaderInfos } from "./erp-work-order-header-infos";
import { ManualTasktemplateAccessibility } from "./manual-tasktemplate-accessibility";
import { DbOrderManualTaskJobInfos } from "./db-order-manual-task-job-infos";
import { DbOrderManualTaskTemplateFormFieldInfos } from "./db-order-manual-task-template-form-field-infos";
import { CurrencyPriceInfos } from "./currency-price-infos";
import { TitleType } from "./title-type";
import { immerable } from "immer";

export class DbOrderManualTaskTemplateInfos extends DbMongoBaseInfos {
  [immerable] = true;
  $type?: any | null | undefined;
  createUserTasks: boolean | null = null;
  isSystem: boolean | null = null;
  isTreatedExternally: boolean | null = null;
  isInternal: boolean | null = null;
  platformId: number | null = 0;
  createdByUserId: number | null = 0;
  productType: OrderProductType | null = OrderProductType.ManualTasks;
  type: OrderManualTaskTemplateTypes | null = null;
  createdDate: Date | null = null;
  description: string | null = null;
  group: string | null = null;
  createdByUserName: string | null = null;
  dynamicPriceRules: boolean | null = null;
  erpTriggerInfos: ERPWorkOrderTriggerInfos | null = null;
  erpHeaderInfos: ERPWorkOrderHeaderInfos | null = null;
  accessibilities: ManualTasktemplateAccessibility[] | null = null;
  accessGroupIds: number[] | null = null;
  titleType: TitleType | null = null;
  jobs: DbOrderManualTaskJobInfos[] | null = [];
  formFields: DbOrderManualTaskTemplateFormFieldInfos[] | null = [];
  pricesSum: CurrencyPriceInfos[] | null = [];

  constructor(init?: Partial<DbOrderManualTaskTemplateInfos>) {
    super();
    Object.assign(this, init);
  }
}
